import axios from "axios";
import Cookies from "js-cookie";
import { CONFIG } from "../../config";
export const quizScoreService = async (userArray, quizID, studentID) => {
	try {
		const authToken = Cookies.get("authToken");
		const response = await axios.post(
			`${CONFIG.COURSEURL}/api/quiz-answer/` + quizID + "/" + studentID,
			userArray,
			authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
		);
		return response.data;
	} catch (error) {
		return "error";
	}
};
